import { ChangeEvent, FC } from 'react';
import FormControl from '../form-control';
import { FormProps } from '../helpers';
import CheckboxBase from './base';

interface Props extends FormProps {
  checked: boolean;
  onChange: (checked: boolean, event: ChangeEvent<HTMLInputElement>) => void;
  labelChecks?: boolean;
}

const Checkbox: FC<Props> = ({
  name,
  checked,
  label = '',
  disabled = false,
  autoFocus = false,
  onChange,
  error = '',
  fullWidth = true,
  labelChecks = true,
}) => {
  return (
    <FormControl label="" error={error} name={name} fullWidth={fullWidth}>
      <CheckboxBase
        checked={checked}
        onChange={onChange}
        name={name}
        label={label}
        error={error}
        fullWidth={fullWidth}
        labelChecks={labelChecks}
        disabled={disabled}
        autoFocus={autoFocus}
      />
    </FormControl>
  );
};

export default Checkbox;
